import React from 'react'
import { CprButton } from 'canopy-styleguide!sofe'
import { MobileDesktopWrapper } from 'src/mobile/mobile-wrapper/mobile-wrapper.component.js'

export default class MfaDeviceDenied extends React.PureComponent {
  render() {
    const { mobile } = this.props;
    const styles = mobile ? {maxWidth: '30rem', width: '100%', height: '4.8rem'} : {}
    return <MobileDesktopWrapper image="https://cdn.canopytax.com/static/login-ui/devices.svg" mobile={this.props.mobile}>
      <div>
        <div className="cps-padding-bottom-24">
          This device was denied access to your account.  Please try logging in again if you feel you received this message in error.
        </div>
        <div>
          <CprButton style={styles} actionType="primary" onClick={ ()=>{this.props.history.push('/login')} }>Return to sign in</CprButton>
        </div>
      </div>
    </MobileDesktopWrapper>
  }
}
